import { module } from "../modular/modular";
import { lerp } from '../utils/maths';
import { gsap } from 'gsap' ;

export default class extends module {
    constructor(m) {
        super(m);

		this.mouse = [0,0];
		this.mouseLerp = [0,0];
		this.lerpOffset = { value: 0 };

		// If cursor is in a position fixed element
		this.isFixed = typeof this.getData('fixed') == 'string';

		this.cursorSlideRatio = 5;
		this.deltaTime = 0;
		this.deltaTimeRatio = 120;
        this.lastTime = 0;

		this.$cursorInner = this.$('cursorInner')[0];
		
		this.bcr = {
			top: 0, 
			left: 0
		}
    }

	init() {

    }

	updateOffset(bcr) {
		this.bcr.top = bcr.top + window.scrollInstance.scroll;
		this.bcr.left = bcr.left;
	}

	display() {
		if(window.isMobile) return;

		this.cancel();
		this.animate();

		this.el.classList.add('is-visible');

		if(this.callbackGsap != undefined) {
			this.callbackGsap.kill();
		}

		this.delayCallbackClass = gsap.delayedCall(0.3,() => {
			this.el.classList.add('-ready');
		});

		gsap.to(this.lerpOffset,{
			value: 0.2,
			duration: 0.1
		});
	}

	hide() {
		if(window.isMobile) return;

		if(this.delayCallbackClass != undefined) {
			this.delayCallbackClass.kill();
		}
		
		this.el.classList.remove('is-visible');
		this.el.classList.remove('-ready');

		this.callbackGsap = gsap.to(this.lerpOffset,{
			value: 0,
			duration: 0.5,
			onComplete: () => {
				this.cancel();
			}
		});
	}

	animate() {
		this.raf = window.requestAnimationFrame(() => this.animate());
		let now = performance.now();

		this.deltaTime = now - this.lastTime;
		this.lastTime = now;

		this.mouse = [window.mouse[0] - this.bcr.left, window.mouse[1] - this.bcr.top];

		this.mouseLerp[0] = lerp(this.mouseLerp[0], this.mouse[0], 1 - (Math.pow(this.lerpOffset.value, this.deltaTime/this.deltaTimeRatio)));
		this.mouseLerp[1] = lerp(this.mouseLerp[1], this.mouse[1], 1 - (Math.pow(this.lerpOffset.value, this.deltaTime/this.deltaTimeRatio)));

		let y = this.mouseLerp[1];

		if(window.scrollInstance.scroll != undefined && !this.isFixed) {
			y += window.scrollInstance.scroll;
		}

		this.el.style.transform = `translate3d(${this.mouseLerp[0]}px,${y}px,0)`
		this.$cursorInner.style.transform = `translate3d(${(this.mouse[0] - this.mouseLerp[0]) / this.cursorSlideRatio}px,${(this.mouse[1] - this.mouseLerp[1])/this.cursorSlideRatio}px,0)`
		
	}

	cancel() {
		if(this.raf) {
			window.cancelAnimationFrame(this.raf);
		}
	}

	destroy() {
		this.cancel();
	}
}
